const REFERENCE_SLOTS = ["S1", "S2", "S3", "F1", "F2", "F3"];
const VERIFIED_CAPTURE_POLICIES = ["closed-candles-v1", "as-of-htf-v2"];

export function isEligibleReferenceVersion(version) {
  return REFERENCE_SLOTS.every((slot) => version?.slots?.[slot]?.imageId
    && VERIFIED_CAPTURE_POLICIES.includes(version.slots[slot].capturePolicy));
}

export function referenceAvailability(packs, eventType, timeframe, direction) {
  const pack = packs.find((entry) => entry.eventType === eventType
    && entry.timeframe === timeframe && entry.direction === direction);
  if (!pack) return { eligible: false, reason: "no pack" };
  if (!pack.enabled) return { eligible: false, reason: "pack disabled" };
  const active = pack.versions.find((entry) => entry.version === pack.activeVersion);
  if (!active || pack.retiredVersions.includes(active.version)) {
    return { eligible: false, reason: "no active version" };
  }
  if (!REFERENCE_SLOTS.every((slot) => active.slots?.[slot]?.imageId)) {
    return { eligible: false, reason: "active version incomplete" };
  }
  if (!isEligibleReferenceVersion(active)) {
    return { eligible: false, reason: "recapture unverified setup images" };
  }
  return { eligible: true, version: active.version, packId: pack.id };
}
